export default __webpack_public_path__ + "static/media/template-img-1-large.8e9aa988.jpg";